module.exports = __webpack_public_path__ + "img/pop-up-project-completed.e3968850.png";